import { render, staticRenderFns } from "./RichTextarea.vue?vue&type=template&id=9ad3ad96&"
import script from "./RichTextarea.vue?vue&type=script&lang=ts&"
export * from "./RichTextarea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports